module.exports = __webpack_public_path__ + "static/media/footer-logo.05e4183b.svg";